export default __webpack_public_path__ + "static/media/info_lab.014e1bae.png";